<div class="loading-container">
    <mat-icon>{{ icon() }}</mat-icon>
    <p class="mt-3">
        {{ textKey() | translate }}
        <span class="loading-dots" aria-hidden="true">
            <span class="dot">.</span>
            <span class="dot">.</span>
            <span class="dot">.</span>
        </span>
    </p>
</div>